var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { QueryChangePart } from '@easyquery/core';
import { View } from './view';
/**
 * The view that represents a data-filtering scenario (a text search for one entity/table)
 */
var DataFilterView = /** @class */ (function (_super) {
    __extends(DataFilterView, _super);
    function DataFilterView() {
        return _super.call(this) || this;
    }
    DataFilterView.prototype.initOptions = function (options) {
        var _this = this;
        options = _super.prototype.initOptions.call(this, options);
        options.result.fetchEmptyQueries = true;
        var query = this.context.getQuery();
        query.addChangedCallback(function () {
            if (_this.resultOptions.clearResultOnQueryChange) {
                _this.context.clearResult();
            }
            if (options.syncQueryOnChange) {
                _this.context.syncQuery();
            }
        });
        this.context.addEventListener('ready', this.fetchData.bind(this));
        return options;
    };
    DataFilterView.prototype.initWidgets = function (options) {
        var _this = this;
        _super.prototype.initWidgets.call(this, options);
        if (this.sortingBarWidget) {
            this.context.getQuery().addChangedCallback(function (ev) {
                var edata = ev.data;
                if (!edata || (edata.part != QueryChangePart.SortingColumns
                    && edata.part != QueryChangePart.Columns && edata.part != QueryChangePart.All)) {
                    return;
                }
                _this.fetchData();
            });
        }
        if (this.filterBarWidget) {
            var widgetType = this.filterBarWidget.getWidgetType();
            options.widgets[widgetType] = options.widgets[widgetType] || {};
            if (!options.widgets[widgetType].applyFilterCallback) {
                options.widgets[widgetType].applyFilterCallback = function () {
                    _this.fetchData();
                };
            }
        }
    };
    /**
     * Obsolete. Left for backward compatibility.
     * Use fetchData() instead
     * @deprecated Use `fetchData()`
     */
    DataFilterView.prototype.applyQueryFilter = function () {
        console.warn('applyQueryFilter is obsolete. Use fetchData instead');
        this.fetchData();
    };
    DataFilterView.prototype.fetchData = function () {
        _super.prototype.fetchData.call(this, { refresh: true });
    };
    return DataFilterView;
}(View));
export { DataFilterView };
//# sourceMappingURL=data_filter_view.js.map